import { useQuery } from "@apollo/client";
import { SHOW_PAYMENT } from "../apollo/queries";
import { useState, useCallback, useEffect } from "react";

const useListPayment = (customerId) => {
  const [pagination, setPagination] = useState({ pageStart: 0, limit: 5 });
  const [shouldFetch, setShouldFetch] = useState(false);

  useEffect(() => {
    if (customerId) {
      setShouldFetch(true);
    }
  }, [customerId]);

  const { loading, error, data, refetch } = useQuery(SHOW_PAYMENT, {
    skip: !shouldFetch,
    variables: { input: { customer_id: customerId, ...pagination } },
    // variables: { input: { ...pagination } },
    fetchPolicy: "network-only",
    onError: (err) => {
      console.error("Error fetching payments:", err.message);
    },
  });

  const handlePageChange = useCallback(
    (page, limit) => {
      console.log("limit, page",limit, page)
      setPagination({ pageStart: page, limit: 5 });
      if (shouldFetch) {
        refetch({ input: { customer_id: customerId, pageStart: page, limit: 5 } });
      }
    },
    [refetch, customerId, shouldFetch]
  );

  return {
    payments: data?.allPayments?.data || [],
    total: data?.allPayments?.total || 0,
    loading,
    error,
    handlePageChange,
    refetch,
  };
};

export default useListPayment;
